const tr = {
  common: {
    clear: 'Temizle',
    cancel: 'İptal',
    view: 'Görüntüle',
    edit: 'Düzenle',
    delete: 'Sil',
    actions: 'İşlem',
    searchColumns: 'Kolon ara',
    showAll: 'Tümünü göster',
    hideAll: 'Tümünü gizle',
    columns: 'Kolonlar',
    resetView: 'Görünümü sıfırla',
    saveView: 'Görünümü kaydet',
    viewSaved: 'Görünüm kaydedildi',
    viewSaveFailed: 'Görünüm kaydedilemedi',
    exportCsv: 'CSV dışa aktar',
    exportExcel: 'Excel dışa aktar',
    noExportData: 'Dışa aktarılacak veri yok.',
    paginationTotal: '{{from}}-{{to}} / {{total}} kayıt',
    column: 'Kolon',
    col: 'Kol',
  },
  dccFileModal: {
    title: 'DCC dosyası seç',
    titleMultiple: 'DCC dosyaları seç',
    searchFolder: 'Klasör ara',
    goToInitial: 'Başlangıç klasörüne git',
    upOneLevel: 'Bir üst klasör',
    refresh: 'Yenile',
    path: 'Yol:',
    filterPlaceholder: 'Listelenenleri ada göre filtrele',
    empty: 'Dosya/klasör bulunamadı',
    preview: 'Önizle',
    select: 'Seç',
    cancel: 'İptal',
    selectedCount: '{{total}} dosya seçildi',
    selectAll: 'Bu klasördeki tüm dosyaları seç',
    clearSelection: 'Temizle',
    selectedName: 'Seçilen: {{name}}',
    doubleClickHint: 'Klasörü açmak için çift tıklayın',
    notAuthenticated: 'Oturum bulunamadı. Lütfen tekrar giriş yapın.',
    loadError: 'DCC klasörü yüklenemedi.',
  },
  corOcr: {
    pageTitle: 'OCR Aracı',
    pageDescription:
      'PDF ve görsellerden metin çıkarır. Dilerseniz yerel dosya yükleyebilir, dilerseniz `/root/uploads` altındaki mevcut bir DCC dosyasını yol vererek okutabilirsiniz.',
    engineTitle: 'OCR motoru',
    engineDescription:
      'Sunucu tarafında PaddleOCR kullanılır. PDF içinde zaten seçilebilir metin varsa önce PyMuPDF ile doğal metin çıkarımı yapılır; gerekirse OCR devreye girer.',
    sourceCard: 'Kaynak Dosya',
    localFile: 'Yerel Dosya',
    serverPath: 'Sunucu Dosya Yolu',
    dropText: 'Dosya seçin veya buraya bırakın',
    dropHint: 'Desteklenen formatlar: PDF, PNG, JPG, BMP, TIFF, WEBP',
    pathPlaceholder: 'Örn: temp/ornek.pdf veya Zimmet/2026/evrak.png',
    selectFromDcc: "DCC'den Dosya Seç",
    selectedServerPath: 'Seçilen sunucu yolu: {{path}}',
    selectedFile: 'Seçilen dosya: {{name}}',
    forceOcrLabel: 'PDF içinde metin olsa bile OCR zorla',
    extract: 'Metni Çıkar',
    resultCard: 'OCR Sonucu',
    engine: 'Motor',
    source: 'Kaynak',
    pages: 'Sayfa',
    chars: 'Karakter',
    resultPlaceholder: 'OCR çıktısı burada görünecek.',
    noResult: 'Henüz OCR sonucu yok.',
    msgNoSession: 'Oturum bulunamadı. Lütfen tekrar giriş yapın.',
    msgSelectFile: 'Lütfen bir dosya seçin.',
    msgEnterPath: 'Lütfen sunucu dosya yolunu girin.',
    msgDone: 'OCR tamamlandı.',
    msgFailed: 'OCR işlemi başarısız oldu.',
  },
  corPdfExtract: {
    pageTitle: 'PDF Metin Çıkarıcı',
    pageDescription:
      "PDF dosyalarından metni sunucu tarafında çıkarır. Dilerseniz yerel bir PDF yükleyebilir, dilerseniz DCC dosya sunucusundaki mevcut bir PDF'i seçebilirsiniz.",
    engineTitle: 'Metin çıkarma motoru',
    engineDescription:
      'Sunucuda PDF içeriği önce doğal metin olarak okunur; yalnızca gerekirse OCR kullanılır. Tüm işlem sunucu tarafında yapılır, bu sayfa yalnızca çıkarılan metni gösterir.',
    sourceCard: 'Kaynak PDF',
    localPdf: 'Yerel PDF',
    serverPdf: 'Sunucu PDF',
    dropText: 'PDF dosyası seçin veya buraya bırakın',
    dropHint: 'Yalnızca .pdf dosyaları desteklenir.',
    pathPlaceholder: 'Örn: temp/forms/form1.pdf',
    selectFromDcc: "DCC'den PDF Seç",
    selectedServerPath: 'Seçilen sunucu yolu: {{path}}',
    selectedFile: 'Seçilen dosya: {{name}}',
    extract: 'Metni Çıkar',
    outputCard: 'PDF Metin Çıktısı',
    outputPlaceholder: 'Çıkarılan metin burada görünecek.',
    noResult: 'Henüz metin çıkarılmadı.',
    msgNoSession: 'Oturum bulunamadı. Lütfen tekrar giriş yapın.',
    msgSelectFile: 'Lütfen bir PDF dosyası seçin.',
    msgEnterPath: 'Lütfen sunucudaki PDF yolunu seçin.',
    msgDone: 'PDF metni çıkarıldı.',
    msgFailed: 'PDF metni çıkarılırken bir hata oluştu.',
  },
  persFihrist: {
    title: 'Telefon Fihristi',
    printTooltip: 'Fihristi Yazdır',
    printTitle: 'Telefon Fihristi',
    searchPlaceholder: 'Ad, Soyad, Telefon, Meslek veya Firma ile ara...',
    colFirstName: 'Ad',
    colLastName: 'Soyad',
    colCompany: 'Firma',
    colOccupation: 'Meslek',
    colPhone: 'Telefon',
    colExtension: 'Dahili No',
  },
  admPersonnel: {
    editTitle: 'Personeli Düzenle',
    edit: 'Düzenle',
    back: 'Listeye Dön',
    save: 'Kaydet',
    cancel: 'Vazgeç',
    loading: 'Personel bilgileri yükleniyor...',
    notFound: 'Personel bulunamadı',
    loadError: 'Personel bilgileri yüklenemedi',
    loadErrorDesc: 'Lütfen daha sonra tekrar deneyin.',
    updated: '{{name}} güncellendi',
    updateError: 'Güncelleme başarısız: {{error}}',
    required: '{{field}} zorunlu',
    invalidEmail: 'Geçerli bir e-posta girin',
    uCodePattern: 'Baş harf + rakamlar (örn. u14175)',
    select: 'Seçiniz',
    occupationNeedsClass: 'Önce işçi sınıfını seçin',
    noOccupation: 'Uygun meslek bulunamadı',
    yearsOld: '{{age}} yaş',
    recordInfo: 'Kayıt #{{id}} · Oluşturma: {{date}}',
    sections: {
      personal: 'Kişisel Bilgiler',
      contact: 'İletişim',
      employment: 'İstihdam',
      identity: 'Kimlik ve Ekipman',
      assets: 'Aktif Zimmetler',
      entitlements: 'İzin ve Seyahat Hakları',
    },
    fields: {
      firstName: 'Ad',
      lastName: 'Soyad',
      gender: 'Cinsiyet',
      dateOfBirth: 'Doğum Tarihi',
      nationality: 'Uyruk',
      bloodType: 'Kan Grubu',
      email: 'E-posta',
      phone: 'Telefon',
      extension: 'Dahili No',
      emergencyContact: 'Acil Durum Kişisi',
      company: 'Firma',
      department: 'Bölüm',
      position: 'Görev',
      laborClass: 'İşçi Sınıfı',
      occupation: 'Meslek',
      hireDate: 'İşe Giriş',
      terminationDate: 'İşten Çıkış',
      status: 'Durum',
      persId: 'Sicil No',
      sapNo: 'SAP No',
      uCode: 'U Kodu',
      passportNo: 'Pasaport No',
      bodySize: 'Beden',
      shoeSize: 'Ayakkabı No',
    },
    enums: {
      active: 'Aktif',
      inactive: 'Pasif',
      terminated: 'Ayrıldı',
      M: 'Erkek',
      F: 'Kadın',
      yes: 'Evet',
      no: 'Hayır',
    },
    assets: {
      code: 'Envanter Kodu',
      serial: 'Seri No',
      model: 'Model',
      variant: 'Varyant',
      brand: 'Marka',
      notes: 'Notlar',
      assignedAt: 'Zimmet Tarihi',
      empty: 'Aktif zimmet kaydı yok',
    },
  },
  admMeters: {
    list: {
      title: 'Sayaçlar',
      addMeter: 'Sayaç Ekle',
      colRoomId: 'Oda ID',
      colType: 'Sayaç Tipi',
      colSerial: 'Seri No',
      colStatus: 'Durum',
      colActions: 'İşlem',
      details: 'Detay',
      edit: 'Düzenle',
      delete: 'Sil',
      deleteConfirm: 'Bu sayacı silmek istediğinizden emin misiniz?',
      yes: 'Evet',
      no: 'Hayır',
      loadError: 'Sayaç verileri alınamadı.',
      deleteSuccess: 'Sayaç silindi.',
      deleteError: 'Sayaç silinemedi.',
    },
    form: {
      editTitle: 'Sayaç Düzenle',
      addTitle: 'Yeni Sayaç Ekle',
      roomLabel: 'Bina/Oda',
      roomRequired: 'Lütfen bir oda seçin!',
      roomPlaceholder: 'Oda seçin',
      typeLabel: 'Sayaç Tipi',
      typeRequired: 'Lütfen sayaç tipini girin!',
      typePlaceholder: 'Sayaç tipi seçin',
      unitLabel: 'Birim',
      unitRequired: 'Lütfen bir birim seçin veya girin!',
      unitExtra: 'Örnek: kWh, m³, GJ, kcal, ...',
      unitPlaceholder: 'Birim girin (ör. kWh, m³, GJ)',
      serialLabel: 'Seri No',
      serialRequired: 'Lütfen seri numarasını girin!',
      statusLabel: 'Durum',
      statusRequired: 'Lütfen bir durum seçin!',
      statusPlaceholder: 'Durum seçin',
      initialValueLabel: 'İlk Değer',
      initialValueTooltip: 'Sayaç ilk kurulduğunda gösterdiği değer. (Varsayılan: 0)',
      initialValuePlaceholder: 'Varsayılan: 0',
      multiplierLabel: 'Çarpan',
      multiplierTooltip: 'Okuma değeri bu katsayı ile çarpılır. (Varsayılan: 1)',
      multiplierPlaceholder: 'Varsayılan: 1',
      update: 'Güncelle',
      save: 'Kaydet',
      roomsError: 'Oda verileri alınamadı.',
      meterError: 'Sayaç bilgileri alınamadı.',
      updateSuccess: 'Sayaç başarıyla güncellendi.',
      addSuccess: 'Sayaç başarıyla eklendi.',
      opError: 'İşlem sırasında bir hata oluştu.',
    },
    bulk: {
      title: 'Aylık Sayaç Okuma Girişi',
      lockedInfo:
        'Önceden girilmiş günlerde sayaç değeri ve not alanı kilitlidir. Düzenlemek için ilgili satırdaki Düzenle butonuna basınız.',
      selectMeterLabel: 'Sayaç Seç:',
      selectMeterPlaceholder: 'Sayaç seçin',
      monthLabel: 'Ay:',
      lastValue: 'Son Sayaç Değeri',
      selectMeterAlert: 'Okuma girmek için lütfen bir sayaç seçin.',
      colDate: 'Tarih',
      colValue: 'Sayaç Değeri',
      colValueWithUnit: 'Sayaç Değeri ({{unit}})',
      edit: 'Düzenle',
      valuePlaceholder: 'Değer',
      valuePlaceholderWithUnit: 'Değer ({{unit}})',
      colNote: 'Not',
      notePlaceholder: 'İsteğe bağlı not',
      colPrev: 'Önceki Değer',
      colDaily: 'Günlük Kullanım',
      invalid: 'Hatalı!',
      fetchError: 'Sayaçlar alınamadı.',
      readingsFetchError: 'Mevcut okuma verileri alınamadı.',
      saveDayError: '{{date}} tarihli okuma kaydedilemedi',
      saveSuccess: 'Okumalar başarıyla kaydedildi!',
      nothingToSave: 'Kaydedilecek okuma yok.',
      chainWarning: 'Bazı günlerdeki değerler bir önceki günden küçük: {{days}}. Bu günler kaydedilmedi!',
      saveAll: 'Tüm Okumaları Kaydet',
    },
  },
  folderManager: {
    title: 'Klasör Yöneticisi',
    listError: 'Liste alınamadı!',
    serverError: 'Sunucuya erişilemedi!',
    enterFolderName: 'Lütfen bir klasör adı girin',
    folderCreated: 'Klasör oluşturuldu!',
    deleteConfirm: 'Silmek istediğinizden emin misiniz?',
    yes: 'Evet',
    no: 'Hayır',
    deleted: 'Silindi!',
    deleteFailed: 'Silme başarısız',
    moveSuccess: 'Taşıma başarılı!',
    copySuccess: 'Kopyalama başarılı!',
    copyFailed: 'Kopyalama başarısız',
    colName: 'Klasör Adı',
    colCreated: 'Oluşturulma Tarihi',
    colActions: 'İşlem',
    move: 'Taşı',
    copy: 'Kopyala',
    delete: 'Sil',
    download: 'İndir',
    preview: 'Önizle',
    parentFolder: 'Üst Klasör',
    newFolderPlaceholder: 'Yeni Klasör Adı',
    create: 'Oluştur',
    loading: 'Yükleniyor...',
    empty: 'Klasör boş.',
    moveTitle: 'Taşıma işlemi',
    movePlaceholder: 'Yeni yol (ör: Klasor/AltKlasor)',
    copyTitle: 'Kopyala',
    copyPlaceholder: 'Hedef yol (ör: klasor/altklasor/dosya.pdf)',
    cancel: 'İptal',
  },
  chemicalMaterials: {
    pageTitle: 'Kimyasal Malzeme Listesi',
    loadError: 'Kimyasal malzemeler yüklenemedi.',
    deleteSuccess: 'Malzeme silindi.',
    deleteError: 'Silme başarısız.',
    updateSuccess: 'Mevcut malzeme güncellendi (miktarlar toplandı)!',
    addSuccess: 'Yeni malzeme başarıyla eklendi!',
    unexpectedError: 'Beklenmeyen bir hata oluştu!',
    colMaterialNo: 'Malzeme No',
    colDescription: 'Açıklama',
    colQuantity: 'Miktar',
    colUnit: 'Birim',
    colSupplier: 'Tedarikçi',
    col12Month: '12 Aylık İhtiyaç',
    colRemaining: 'Kalan Stok',
    colCreatedAt: 'Oluşturulma',
    quickAddTitle: 'Hızlı Malzeme Ekle',
    required: 'Gerekli',
    add: 'Ekle',
    downloadExcel: 'Excel Şablonunu İndir',
    downloadCsv: 'CSV Şablonunu İndir',
    uploadInfoTitle: 'Yükleme Bilgilendirmesi:',
    uploadInfoFormat: 'Dosya formatı CSV veya Excel (.xlsx) olabilir.',
    uploadRequiredHeaders: 'Zorunlu başlıklar:',
    uploadInfoUnitValues:
      'unit alanı için kabul edilen değerler ve açıklamaları şablonun ikinci sekmesinde (veya alttaki tabloda) yer alır.',
    uploadInfoUnitNames: 'Birim adını veya sembolünü kullanabilirsiniz. Ayrıntı için şablona bakınız.',
    globalSearchPlaceholder: 'Genel arama (tüm alanlarda)',
    unitFilterPlaceholder: 'Birim filtresi',
    supplierSearchPlaceholder: 'Tedarikçi ara',
    printList: 'Listeyi Yazdır',
  },
  header: {
    language: 'Dil',
    goHome: 'Ana Sayfa',
    assignedTasks: 'Atanmış görevler',
    goToProfile: 'Profile git',
    logout: 'Çıkış',
    login: 'Giriş',
    userPrefix: 'Kullanıcı',
  },
  auth: {
    loginTitle: 'Kullanıcı girişi',
    username: 'Kullanıcı adı',
    password: 'Şifre',
    usernameRequired: 'Kullanıcı adını giriniz',
    passwordRequired: 'Şifrenizi giriniz',
    loginSuccess: 'Giriş başarılı',
    loginError: 'Kullanıcı adı veya şifre hatalı.',
  },
  home: {
    appTitle: 'Proje Bilgi Platformu',
    weatherNow: 'Anlık hava',
    wind: 'Rüzgar',
    humidity: 'Nem',
    pressure: 'Basınç',
    precipitation: 'Yağış',
    noWeatherData: 'Hava durumu verisi yok',
    projectTimeline: 'Proje takvimi',
    start: 'Başlangıç',
    end: 'Bitiş',
    elapsed: 'Geçen',
    timeRemaining: 'Kalan süre',
    years: 'Yıl',
    months: 'Ay',
    days: 'Gün',
    daysRemaining: '{{count}} gün kaldı',
    openModule: '{{module}} aç',
    todaysMenu: 'Günün Menüsü',
    lunch: 'Öğle',
    dinner: 'Akşam',
    noMenuToday: 'Bugün için menü girilmedi',
    myTasks: 'Bekleyen İşlerim',
    tasksEmpty: 'Bekleyen işiniz yok 🎉',
    tasksLoginPrompt: 'Görevlerinizi görmek için giriş yapın',
    viewAllTasks: 'Tümünü gör',
  },
  tasks: {
    title: 'Görevlerim',
    filterPending: 'Bekleyen',
    filterCompleted: 'Tamamlanan',
    filterAll: 'Tümü',
    colType: 'Tip',
    colDescription: 'Açıklama',
    colStatus: 'Durum',
    colCreated: 'Oluşturulma',
    go: 'Git',
    complete: 'Tamamla',
    completedMsg: 'Görev tamamlandı',
    empty: 'Görev bulunamadı',
    typeAction: 'Onay',
    typeNotify: 'Bilgi',
    status: {
      pending: 'Bekliyor',
      'in progress': 'Devam ediyor',
      blocked: 'Sırada',
      completed: 'Tamamlandı',
      cancelled: 'İptal',
    },
  },
  kitchen: {
    recipes: {
      title: 'Tarif Listesi',
      createNew: 'Yeni Tarif Oluştur',
      searchByName: 'Ada göre ara',
      selectCategory: 'Kategori seç',
      selectCuisine: 'Mutfak seç',
      selectStatus: 'Tarif durumu seç',
      allCategories: 'Tüm Kategoriler',
      allCuisines: 'Tüm Mutfaklar',
      allStatuses: 'Tüm Durumlar',
      colName: 'Tarif Adı',
      colCategory: 'Kategori',
      colCuisine: 'Mutfak',
      colServingSize: 'Porsiyon',
      colPrep: 'Hazırlık (dk)',
      colCook: 'Pişirme (dk)',
      colStatus: 'Durum',
      colActions: 'İşlem',
      deleteConfirmTitle: 'Silme Onayı',
      deleteConfirmContent:
        '"{{name}}" tarifini (ID: {{id}}) ve tüm bağlı malzemelerini silmek istediğinizden emin misiniz?',
      deleteIrreversible: 'Bu işlem geri alınamaz.',
      deleteOk: 'Sil',
      deleteCancel: 'İptal',
      deleteSuccess: '{{id}} ID numaralı tarif ve bağlı malzemeleri başarıyla silindi!',
      deleteMaybeFailed:
        '{{id}} ID numaralı tarif silinememiş olabilir (veya malzeme silme başarısız oldu). Yanıt: {{msg}}',
      deleteError: '{{id}} ID numaralı tarifin silme işlemi tamamlanamadı: {{error}}',
      loadErrorTitle: 'Hata',
      loadError: 'Tarifler yüklenemedi: {{error}}',
    },
    mealType: {
      Breakfast: 'Kahvaltı',
      Lunch: 'Öğle',
      Dinner: 'Akşam',
      Snack: 'Ara Öğün',
      Suhoor: 'Sahur',
      Iftar: 'İftar',
      Event: 'Etkinlik',
      Package: 'Paket',
    },
    weekly: {
      title: 'Haftalık Menü Planlayıcı',
      prevWeek: 'Önceki',
      nextWeek: 'Sonraki',
      copyPrevWeek: 'Geçen Haftayı Kopyala',
      copyPrevWeekDone: 'Geçen haftanın menüsü kopyalandı (kaydetmeyi unutmayın)',
      copyPrevWeekEmpty: 'Geçen hafta için menü bulunamadı',
      saveWeek: 'Haftayı Kaydet',
      saved: 'Haftalık menü kaydedildi',
      saveError: 'Kaydetme sırasında hata: {{error}}',
      unsaved: 'Kaydedilmemiş değişiklikler var',
      visibleMeals: 'Görünen öğünler',
      servings: 'Porsiyon',
      selectRecipes: 'Yemek seç...',
      copyDay: 'Bu günü kopyala',
      day: 'Gün',
      meal: 'Öğün',
      course: 'Çeşit {{n}}',
      loadError: 'Menü verisi yüklenemedi',
    },
  },
  machinery: {
    allocations: {
      createTitle: 'Makine Rezervasyonu / Tahsis Oluştur',
      viewTitle: 'Makine Rezervasyonu / Tahsis Detayı',
      selectWpOrActivity: 'Lütfen bir İş İzni (Work Permit) veya Aktivite seçin',
      activityMissing: 'Aktivite Kodu / Adı eksik. Lütfen seçimi tamamlayın.',
      overlapFrontend:
        'Seçtiğiniz zaman aralığı bu makinenin mevcut rezervasyonlarıyla çakışıyor. Lütfen farklı bir aralık seçin.',
      noIdReturned: 'Kayıt ID bilgisi geri dönmedi',
      createSuccess: 'Rezervasyon talebi başarıyla oluşturuldu.',
      overlapDb:
        'Bu makine için seçtiğiniz zaman aralığında zaten bir rezervasyon var. Lütfen farklı bir zaman aralığı seçin.',
      createFailed: 'Rezervasyon oluşturulamadı',
      startTime: 'Başlangıç Zamanı',
      startTimeRequired: 'Lütfen başlangıç zamanı seçin',
      endTime: 'Bitiş Zamanı',
      endTimeRequired: 'Lütfen bitiş zamanı seçin',
      machine: 'Makine',
      machineRequired: 'Lütfen makine seçin',
      machinePlaceholder: 'Makine seçin',
      company: 'Firma',
      companyRequired: 'Lütfen firma seçin',
      companyPlaceholder: 'Firma seçin',
      existingTitle: 'Seçili Makine - Mevcut Rezervasyonlar',
      existingHint: 'Mevcut rezervasyonları görmek için lütfen bir makine seçin.',
      existingEmpty: 'Bu makine için henüz rezervasyon yok.',
      colStart: 'Başlangıç',
      colEnd: 'Bitiş',
      colStatus: 'Durum',
      requester: 'Talep Eden',
      requesterRequired: 'Lütfen talep eden personeli seçin',
      requesterPlaceholder: 'Talep eden seçin',
      approver: 'Onaylayan',
      approverRequired: 'Lütfen onaylayacak personeli seçin',
      approverPlaceholder: 'Onaylayan seçin',
      location: 'Lokasyon',
      locationRequired: 'Lütfen lokasyon girin',
      description: 'Açıklama',
      descriptionRequired: 'Lütfen açıklama girin',
      descriptionPlaceholder: 'Yapılacak işin açıklaması',
      wpActivityTitle: 'İş İzni / Aktivite',
      pickWorkPermit: 'İş İzni Seç',
      wpPlaceholder: 'İş İzni Ref - Açıklama',
      clear: 'Temizle',
      pickActivity: 'Aktivite Seç',
      activityCombinedPlaceholder: 'Aktivite Kodu - Adı',
      activityCode: 'Aktivite Kodu',
      activityName: 'Aktivite Adı',
      cancel: 'Vazgeç',
      createReservation: 'Rezervasyon Oluştur',
      recordNotFound: 'Kayıt bulunamadı',
      recordLoadFailed: 'Kayıt yüklenemedi',
      onlyApprover: 'Rezervasyon durumunu yalnızca atanmış onaylayıcı değiştirebilir.',
      statusUpdated: 'Durum {{status}} olarak güncellendi',
      statusUpdateFailed: 'Durum güncellenemedi',
      cancelConfirm: 'Rezervasyonu iptal etmek istediğinizden emin misiniz?',
      cancelOk: 'Evet, iptal et',
      rejectConfirm: 'Rezervasyonu reddetmek istediğinizden emin misiniz?',
      rejectOk: 'Evet, reddet',
      no: 'Vazgeç',
      selectNewTimes: 'Lütfen yeni başlangıç ve bitiş zamanlarını seçin',
      endAfterStart: 'Bitiş zamanı başlangıçtan sonra olmalı',
      backToList: 'Listeye dön',
      approve: 'Onayla',
      defer: 'Ertele',
      reject: 'Reddet',
      workPermitRef: 'İş İzni Ref',
      activity: 'Aktivite',
      deferTitle: 'Rezervasyonu Ertele',
      save: 'Kaydet',
      newStart: 'Yeni başlangıç zamanı',
      newEnd: 'Yeni bitiş zamanı',
      unknown: 'Bilinmiyor',
    },
    hub: {
      title: 'Machinery / Kademe',
      description: 'Kademe operasyonları için ana erişim ekranı. Ek veri yükü oluşturmadan hızlı yönlendirme sağlar.',
      subtitle: 'Bakım, araçlar, rezervasyonlar, formlar ve yakıt takibi buradan yönetilebilir.',
      operation: 'Operasyon',
      maintenanceAndRecords: 'Bakım ve Kayıt',
      formsAndFuel: 'Formlar ve Yakıt',
      goToScreen: 'Ekrana Git',
      tags: {
        list: 'Liste',
        detail: 'Detay',
        vehicle: 'Araç',
        user: 'Kullanıcı',
        reservation: 'Rezervasyon',
        request: 'Talep',
        personnel: 'Personel',
        assignment: 'Atama',
        maintenance: 'Bakım',
        record: 'Kayıt',
        definition: 'Tanım',
        class: 'Sınıf',
        period: 'Periyot',
        threshold: 'Eşik',
        alert: 'Uyarı',
        tracking: 'Takip',
        form: 'Form',
        import: 'İçe Aktarım',
      },
      cards: {
        machines: {
          title: 'Makine Parkı',
          subtitle: 'Machines',
          description: 'Makine listesi, detayları ve ekipman takibi.',
        },
        vehicles: {
          title: 'Araçlar',
          subtitle: 'Vehicles',
          description: 'Araç kayıtları, kullanıcı atamaları ve genel durum takibi.',
        },
        allocations: {
          title: 'Rezervasyon / Tahsis',
          subtitle: 'Reservations / Allocation',
          description: 'Makine rezervasyonları ve tahsis süreçleri.',
        },
        assignments: {
          title: 'Zimmet / Atama',
          subtitle: 'Assignments',
          description: 'Araçların personel bazlı kullanım atamaları.',
        },
        maintenance: {
          title: 'Bakım Kayıtları',
          subtitle: 'Maintenance',
          description: 'Bakım girişleri, geçmiş kayıtlar ve işlem takibi.',
        },
        maintenanceTypes: {
          title: 'Bakım Tipleri',
          subtitle: 'Maintenance Types',
          description: 'Bakım sınıfları ve uygulanabilir makine tipleri.',
        },
        maintenanceRules: {
          title: 'Bakım Kuralları',
          subtitle: 'Maintenance Rules',
          description: 'Periyot, eşik ve uyarı mantıklarının yönetimi.',
        },
        maintenanceAlerts: {
          title: 'Bakım Uyarıları',
          subtitle: 'Maintenance Alerts',
          description: 'Yaklaşan ve geciken bakım ihtiyaçlarının görünümü.',
        },
        forms: {
          title: 'Formlar',
          subtitle: 'Forms',
          description: 'Makine formları, tanımları ve kayıt detayları.',
        },
        fuel: {
          title: 'Yakıt Takibi',
          subtitle: 'Fuel Tracking',
          description: 'Yakıt hareketleri, geçmiş kayıtlar ve içe aktarma ekranları.',
        },
      },
    },
    machines: {
      common: {
        cancel: 'İptal',
        save: 'Kaydet',
        yes: 'Evet',
        no: 'Hayır',
      },
    },
    vehicles: {
      common: {
        available: 'Müsait',
        assigned: 'Atanmış',
        inMaintenance: 'Bakımda',
        outOfService: 'Servis Dışı',
        inactive: 'Pasif',
      },
    },
    fuel: {
      common: {
        import: 'Yakıt Iceri Aktar',
        overviewTab: 'Özet',
        entryTab: 'Yakıt Girişi',
        historyTab: 'Yakıt Geçmişi',
        pumpsTab: 'Pompa Yönetimi',
        transfersTab: 'Stok Transferleri',
      },
      import: {
        title: 'Yakıt Kayıt Içe Aktarma',
        description: 'Yakıt kayıtlarını',
        descriptionSuffix: 'tablosuna Excel/CSV ile toplu aktarabilirsiniz.',
        expectedColumns: 'Beklenen kolonlar',
        required: '(zorunlu)',
      },
      entry: {
        title: 'Yakıt Giriş Formu',
        vehicle: 'Araç',
        vehicleRequired: 'Araç seçiniz',
        vehiclePlaceholder: 'Araç seçiniz',
        vehicleFuelType: 'Araç Yakıt Tipi',
        personnel: 'Personel',
        personnelRequired: 'Personel seçiniz',
        personnelPlaceholder: 'Personel seçiniz',
        date: 'Tarih',
        dateRequired: 'Tarih seçiniz',
        odometer: 'Kilometre',
        hourCounter: 'Saat Sayacı',
        liters: 'Yakıt (Lt)',
        litersRequired: 'Litre bilgisi giriniz',
        fuelType: 'Yakıt Tipi',
        fuelTypeRequired: 'Yakıt tipi seçiniz',
        fuelTypePlaceholder: 'Yakıt tipi seçiniz',
        sourceType: 'Kaynak Tipi',
        sourceTypeRequired: 'Kaynak tipi seçiniz',
        sourceTypePlaceholder: 'Kaynak tipi seçiniz',
        sourceTypeFixedPump: 'Sabit Pompa',
        sourceTypeFuelTanker: 'Yakıt Tankeri',
        sourceTypeExternal: 'Harici Kaynak',
        sourcePump: 'Pompa',
        sourcePumpRequired: 'Pompa seçiniz',
        sourcePumpPlaceholder: 'Pompa seçiniz',
        sourceTanker: 'Tanker',
        sourceTankerRequired: 'Tanker seçiniz',
        sourceTankerPlaceholder: 'Tanker seçiniz',
        sourceName: 'Kaynak Adı',
        sourceNameRequired: 'Kaynak adı giriniz',
        sourceNamePlaceholder: 'Kaynak adı giriniz',
        location: 'Konum',
        locationPlaceholder: 'Konum giriniz',
        referenceNo: 'Referans No',
        referenceNoPlaceholder: 'Referans no giriniz',
        station: 'İstasyon',
        stationPlaceholder: 'Istasyon giriniz',
        company: 'Firma',
        companyPlaceholder: 'Firma giriniz',
        note: 'Not',
        notePlaceholder: 'Not giriniz',
        currentKilometer: 'Mevcut KM',
        currentHours: 'Mevcut Saat',
        save: 'Kaydet',
        addSuccess: 'Yakıt kaydı eklendi',
        addFailed: 'Yakıt kaydı eklenemedi: {{message}}',
      },
      history: {
        title: 'Yakıt Geçmişi',
        searchPlaceholder: 'Araç, personel, firma, istasyon veya not ara...',
        vehiclePlaceholder: 'Araç',
        sourceTypePlaceholder: 'Kaynak tipi',
        refresh: 'Yenile',
        vehicle: 'Araç',
        date: 'Tarih',
        personnel: 'Personel',
        fuelType: 'Yakıt Tipi',
        sourceType: 'Kaynak Tipi',
        source: 'Kaynak',
        sourceTypeFixedPump: 'Sabit Pompa',
        sourceTypeFuelTanker: 'Yakıt Tankeri',
        sourceTypeExternal: 'Harici Kaynak',
        odometer: 'Kilometre',
        hourCounter: 'Saat Sayacı',
        liters: 'Litre',
        company: 'Firma',
        station: 'İstasyon',
        location: 'Konum',
        referenceNo: 'Referans No',
        note: 'Not',
      },
      pumps: {
        title: 'Yakıt Pompaları',
        addButton: 'Yeni Pompa',
        addTitle: 'Yeni Pompa',
        editTitle: 'Pompa Düzenle',
        searchPlaceholder: 'Pompa adı, kod, konum veya firma ara...',
        name: 'Pompa Adı',
        nameRequired: 'Pompa adı giriniz',
        namePlaceholder: 'Pompa adı giriniz',
        code: 'Kod',
        codePlaceholder: 'Pompa kodu giriniz',
        fuelType: 'Yakıt Tipi',
        fuelTypeRequired: 'Yakıt tipi seçiniz',
        fuelTypePlaceholder: 'Yakıt tipi seçiniz',
        location: 'Konum',
        locationPlaceholder: 'Konum giriniz',
        capacityLiters: 'Kapasite (Lt)',
        openingStockLiters: 'Açılış Stoğu (Lt)',
        openingStockRequired: 'Açılış stoğu giriniz',
        status: 'Durum',
        statusRequired: 'Durum seçiniz',
        statusPlaceholder: 'Durum seçiniz',
        statusActive: 'Aktif',
        statusInactive: 'Pasif',
        statusOutOfService: 'Devre Dışı',
        company: 'Firma',
        companyPlaceholder: 'Firma seçiniz',
        note: 'Not',
        notePlaceholder: 'Not giriniz',
        addSuccess: 'Pompa kaydı eklendi',
        updateSuccess: 'Pompa kaydı güncellendi',
        operationFailed: 'Pompa işlemi başarısız: {{message}}',
      },
      transfers: {
        title: 'Yakıt Kaynak Transferleri',
        addButton: 'Yeni Transfer',
        addTitle: 'Yeni Yakıt Transferi',
        searchPlaceholder: 'Kaynak, hedef, referans veya konum ara...',
        date: 'Tarih',
        dateRequired: 'Tarih seçiniz',
        sourceType: 'Kaynak Tipi',
        sourceTypeRequired: 'Kaynak tipi seçiniz',
        sourceTypePlaceholder: 'Kaynak tipi seçiniz',
        sourceTypeMainDepot: 'Ana Depo',
        sourceTypeFixedPump: 'Sabit Pompa',
        sourceTypeFuelTanker: 'Yakıt Tankeri',
        sourceTypeExternalSupplier: 'Harici Tedarikçi',
        sourceTypeAdjustment: 'Stok Düzeltme',
        source: 'Kaynak',
        sourcePump: 'Kaynak Pompa',
        sourcePumpRequired: 'Kaynak pompa seçiniz',
        sourcePumpPlaceholder: 'Kaynak pompa seçiniz',
        sourceTanker: 'Kaynak Tanker',
        sourceTankerRequired: 'Kaynak tanker seçiniz',
        sourceTankerPlaceholder: 'Kaynak tanker seçiniz',
        sourceName: 'Kaynak Adı',
        sourceNameRequired: 'Kaynak adı giriniz',
        sourceNamePlaceholder: 'Kaynak adı giriniz',
        targetType: 'Hedef Tipi',
        targetTypeRequired: 'Hedef tipi seçiniz',
        targetTypePlaceholder: 'Hedef tipi seçiniz',
        targetTypeFixedPump: 'Sabit Pompa',
        targetTypeFuelTanker: 'Yakıt Tankeri',
        target: 'Hedef',
        targetPump: 'Hedef Pompa',
        targetPumpRequired: 'Hedef pompa seçiniz',
        targetPumpPlaceholder: 'Hedef pompa seçiniz',
        targetTanker: 'Hedef Tanker',
        targetTankerRequired: 'Hedef tanker seçiniz',
        targetTankerPlaceholder: 'Hedef tanker seçiniz',
        fuelType: 'Yakıt Tipi',
        fuelTypeRequired: 'Yakıt tipi seçiniz',
        fuelTypePlaceholder: 'Yakıt tipi seçiniz',
        liters: 'Litre',
        litersRequired: 'Litre giriniz',
        personnel: 'Personel',
        personnelPlaceholder: 'Personel seçiniz',
        company: 'Firma',
        companyPlaceholder: 'Firma seçiniz',
        location: 'Konum',
        locationPlaceholder: 'Konum giriniz',
        referenceNo: 'Referans No',
        referenceNoPlaceholder: 'Referans no giriniz',
        note: 'Not',
        notePlaceholder: 'Not giriniz',
        addSuccess: 'Transfer kaydı eklendi',
        operationFailed: 'Transfer işlemi başarısız: {{message}}',
        sameSourceTargetError: 'Kaynak ve hedef aynı olamaz.',
      },
      overview: {
        title: 'Yakıt Özeti',
        stockTitle: 'Pompa ve Tanker Stok Görünümü',
        vehicleConsumptionTitle: 'Araç Tüketim Özeti',
        ledgerTitle: 'Kaynak Hareket Dökümü',
        fuelTypePlaceholder: 'Yakıt tipi',
        assetPlaceholder: 'Kaynak seçiniz',
        totalDispensedRange: 'Aralıkta Verilen Yakıt (Lt)',
        totalTransferredRange: 'Aralıkta Transfer (Lt)',
        totalClosingStock: 'Toplam Kapanış Stoğu (Lt)',
        totalAssetsTracked: 'İzlenen Kaynak',
        assetType: 'Varlık Tipi',
        assetTypePump: 'Pompa',
        assetTypeTanker: 'Tanker',
        assetName: 'Varlık',
        fuelType: 'Yakıt Tipi',
        status: 'Durum',
        location: 'Konum',
        openingStock: 'Açılış Stoğu',
        incomingRange: 'Aralık Giriş',
        outgoingRange: 'Aralık Çıkış',
        dispensedRange: 'Aralık Dağıtım',
        closingStock: 'Kapanış Stoğu',
        vehicle: 'Araç',
        totalLiters: 'Toplam Litre',
        entryCount: 'Kayıt',
        avgLiters: 'Ort. Litre',
        kmDelta: 'KM Farkı',
        litersPer100Km: 'Lt / 100 KM',
        hoursDelta: 'Saat Farkı',
        litersPerHour: 'Lt / Saat',
        lastEntryDate: 'Son Giriş',
        referenceNo: 'Referans No',
        note: 'Not',
        ledgerDate: 'Tarih',
        ledgerMovementType: 'Hareket Tipi',
        ledgerTransferIn: 'Transfer Giriş',
        ledgerTransferOut: 'Transfer Çıkış',
        ledgerDispense: 'Araça Verilen',
        ledgerSource: 'Kaynak',
        ledgerTarget: 'Hedef',
        ledgerIn: 'Giriş',
        ledgerOut: 'Çıkış',
        ledgerBalance: 'Bakiye',
      },
    },
    maintenance: {
      common: {
        maintenanceType: 'Bakım Tipi',
        description: 'Açıklama',
        vehicle: 'Araç',
        status: 'Durum',
        date: 'Tarih',
        type: 'Tip',
        searchNameDescription: 'İsim/açıklama ara...',
        operationFailed: 'İşlem başarısız',
      },
      types: {
        title: 'Bakım Tipleri',
        addButton: 'Yeni Tip',
        name: 'Ad',
        applicableTypes: 'Uygulanabilir Tipler',
        duplicateName: 'Aynı isimde bakım tipi zaten mevcut',
        updateSuccess: 'Bakım tipi güncellendi',
        addSuccess: 'Bakım tipi eklendi',
        editTitle: 'Bakım Tipi Düzenle',
        addTitle: 'Yeni Bakım Tipi',
        nameRequired: 'Ad zorunlu',
        namePlaceholder: 'Örn: Periyodik Bakım',
        applicableTypesLabel: 'Uygulanabilir Makine Tipleri',
        applicableTypesPlaceholder: 'Makine tipleri seçin (opsiyonel)',
      },
      rules: {
        title: 'Bakım Kuralları',
        addButton: 'Yeni Kural',
        searchPlaceholder: 'Bakım tipi ara...',
        typePlaceholder: 'Bakım Tipi',
        intervalKm: 'Aralık (KM)',
        intervalHours: 'Aralık (Saat)',
        intervalDays: 'Aralık (Gün)',
        warningKm: 'Uyarı KM',
        warningHours: 'Uyarı Saat',
        warningDays: 'Uyarı Gün',
        typeRequired: 'Bakım tipi zorunlu',
        selectPlaceholder: 'Seçin',
        minOneInterval: 'En az bir bakım aralığı girilmelidir',
        warningKmTooHigh: 'Uyarı KM değeri bakım aralığından büyük olamaz',
        warningHoursTooHigh: 'Uyarı saat değeri bakım aralığından büyük olamaz',
        warningDaysTooHigh: 'Uyarı gün değeri bakım aralığından büyük olamaz',
        duplicateRule: 'Bu bakım tipi için zaten bir kural mevcut',
        updateSuccess: 'Kural güncellendi',
        addSuccess: 'Kural eklendi',
        editTitle: 'Kuralı Düzenle',
        addTitle: 'Yeni Kural',
      },
      list: {
        title: 'Bakım Kayıtları',
        addButton: 'Yeni Bakım',
        searchPlaceholder: 'Araç, bakım tipi veya açıklama ara...',
        vehiclePlaceholder: 'Araç',
        typePlaceholder: 'Bakım Tipi',
        maintenanceDate: 'Bakım Tarihi',
        performedKm: 'Yapılan KM',
        performedHours: 'Yapılan Saat',
        deleteConfirm: 'Bakım kaydını silmek istediğinizden emin misiniz?',
        deleteSuccess: 'Bakım kaydı silindi',
        deleteFailed: 'Kayıt silinemedi',
        updateSuccess: 'Bakım kaydı güncellendi',
        addSuccess: 'Bakım kaydı eklendi',
        addFailed: 'Kayıt eklenemedi',
        editTitle: 'Bakım Kaydını Düzenle',
        addTitle: 'Yeni Bakım',
        vehicleRequired: 'Araç zorunlu',
        vehicleSelectPlaceholder: 'Araç seçin',
        typeSelectPlaceholder: 'Tip seçin (opsiyonel)',
        dateRequired: 'Tarih zorunlu',
      },
      alerts: {
        title: 'Bakım Uyarıları',
        searchPlaceholder: 'Araç, bakım tipi veya not ara...',
        vehiclePlaceholder: 'Araç',
        typePlaceholder: 'Bakım Tipi',
        statusPlaceholder: 'Durum',
        dueDate: 'Vade Tarihi',
        dueKm: 'Vade KM',
        dueHours: 'Vade Saat',
        note: 'Not',
        approaching: 'Yaklaşıyor',
        due: 'Bakım Gerekli',
        overdue: 'Gecikmiş',
      },
    },
  },
  routes: {
    core: {
      general: 'Genel',
      currencies: 'Para Birimleri',
      units: 'Birimler',
      countries: 'Ülkeler',
      foodIngredients: 'Gıda Malzemeleri',
      professions: 'Meslekler',
      folderUploads: 'Klasör yüklemeleri',
      whiteboard: 'Cizim tahtasi',
      apiEndpoints: 'API Uçları',
      imageCompressor: 'Görsel Küçültücü',
      pdfToReact: 'PDF’den React Form',
      pdfToSvg: 'PDF’den SVG',
      pdfTextExtract: 'PDF Metin Çıkarma',
      exifReader: 'Foto EXIF Okuyucu',
    },
    dcc: {
      ocr: 'OCR',
    },
  },
  coreGeneral: {
    title: 'Genel',
    subtitle: 'Proje genelinde paylaşılan listeler ve araçlar.',
    currenciesHint: 'Kodlar ve simgeler',
    unitsHint: 'Ölçü birimleri',
    countriesHint: 'Ülke kayıtları',
    foodIngredientsHint: 'Malzeme kataloğu',
    professionsHint: 'Meslek ve işçilik türleri',
    pdfToReactHint: 'PDF’ten form oluştur',
    pdfToSvgHint: 'PDF sayfasını SVG’ye çevir',
    pdfTextExtractHint: 'PDF içinden metin çıkar',
    exifReaderHint: 'Fotoğraf metadata’sını oku',
    empty: 'Bu hesap için görüntülenebilir liste yok.',
  },
  coreWhiteboard: {
    title: 'Cizim tahtasi',
    description:
      'Bu ilk surum tek kullanicili ve kaydetmesiz calisir. Sayfa yalnizca acildiginda yuklenir; ana uygulamaya gereksiz yuk bindirmez.',
    info: 'Cizimler bu surumde proje veritabani veya dosya sistemine kaydedilmez.',
  },
  coreFolderUploads: {
    pageTitle: 'Klasör yüklemeleri',
    pageSubtitle:
      'Solda klasörler arasında gezinin; sağda dosya veya klasör ekleyip tek seferde seçili hedefe yükleyin.',
    breadcrumbRoot: 'Root',
    columnFolder: 'Klasör',
    columnType: 'Tür',
    typeFolder: 'Klasör',
    typeFile: 'Dosya',
    listTitle: 'Sunucu klasörleri',
    refresh: 'Yenile',
    loadingFoldersTip: 'Klasörler yükleniyor…',
    emptyFolders: 'Klasör bulunamadı.',
    searchPlaceholder: 'Bu yoldaki klasörlerde ara…',
    emptyFiltered: 'Aramanızla eşleşen klasör yok.',
    uploadCardTitle: 'Yükleme',
    uploadTargetLabel: 'Yükleme hedefi',
    tagServer: 'Sunucu',
    hintRootTarget:
      'Kök yükleme dizini seçili. Alt klasöre yüklemek için soldan ilgili klasöre girin.',
    hintSubPathPrefix: 'Seçili alt yol:',
    browseHint:
      'Yükleme hedefini değiştirmek için bir alt klasöre tıklayarak içine girin{{syncSuffix}}.',
    browseHintSyncOn: ' (hedef otomatik güncellenir)',
    browseHintSyncOff: '; hedef sabitse yukarıdaki düğmeyi kullanın',
    syncCheckbox: 'Gezinirken yükleme hedefini otomatik güncelle',
    setBrowseAsTarget: 'Gezindiğim klasörü yükleme hedefi yap',
    targetSetSuccess: 'Yükleme hedefi, şu an görüntülediğiniz klasör olarak ayarlandı.',
    alertTitleMismatch: 'Yükleme hedefi ile gezinti farklı',
    labelDisplayed: 'Görüntülenen:',
    labelFilesGoTo: 'Dosyaların gideceği yer:',
    newFolderPlaceholder: 'Yeni klasör adı',
    createFolder: 'Klasör oluştur',
    goUp: 'Üst klasör',
    uploadModeFiles: 'Dosya modu',
    uploadModeFolders: 'Klasör modu',
    uploadClickOrDragFiles: 'Dosyaları seçmek için tıklayın ya da buraya sürükleyin',
    uploadClickOrDragFolders: 'Klasör eklemek için tıklayın ya da birkaç klasörü buraya sürükleyin',
    uploadHintFiles: 'Çoklu dosya seçimi ve sürükle-bırak desteklenir.',
    uploadHintFolders: 'Yalnızca dosya içeren klasörler de eklenir. Birkaç klasörü birlikte sürükleyerek tek seferde ekleyin.',
    selectMultipleFolders: 'Birden fazla klasör seç',
    addOneFolder: 'Tek klasör ekle',
    chooseChildFoldersTitle: '{{name}} içindeki klasörler',
    chooseChildFoldersHint: 'Dahil edilecek klasörleri işaretleyin. Seçilen her klasör, dosyaları ve alt klasörleriyle eklenir.',
    chooseChildFoldersOk: 'Seçilen klasörleri ekle',
    selectAllFolders: 'Tümünü seç',
    clearFolderChecks: 'Temizle',
    pickerMultiUnsupported: 'Bu tarayıcı çoklu klasör listesini açamıyor. Klasörleri yukarıdaki alana sürükleyin.',
    noChildFolders: 'Bu klasörün alt klasörü yok.',
    chooseChildFoldersEmpty: 'En az bir klasör seçin.',
    uploadSelected: 'Seçileni yükle',
    clearSelection: 'Temizle',
    pendingFilesTag: 'Bekleyen dosya: {{count}}',
    pendingFoldersTag: 'Bekleyen klasör: {{count}}',
    pendingLooseFilesTag: 'Düz dosya: {{count}}',
    pendingReadyHint: 'Seçilen tüm dosya ve klasörler tek partide yüklenecek.',
    pendingEmptyHint: 'Henüz yükleme kuyruğuna eklenmiş dosya veya klasör yok.',
    folderMultiHint:
      'Her tıklama, alt klasörü olmasa da seçtiğiniz klasörü ekler. Bu klasörlerden birkaçını birlikte eklemek için Dosya Gezgini\'nde seçip bu alana sürükleyin.',
    dropReleaseFolders: 'Klasörleri eklemek için bırakın',
    dropReleaseFiles: 'Dosyaları eklemek için bırakın',
    progressReading: 'Dosyalar okunuyor…',
    progressPacking: 'Arşiv oluşturuluyor…',
    progressUploading: 'Yükleniyor…',
    readingDropped: 'Sürüklenen klasörler okunuyor…',
    removeQueued: 'Kuyruktan çıkar',
    queuedItemCount: '{{count}} dosya',
    messages: {
      listFailed: 'Klasör listesi alınamadı.',
      serverUnreachable: 'Yükleme sunucusuna ulaşılamadı.',
      loginRequired: 'Yükleme için oturum açmanız gerekir.',
      uploading: 'Dosyalar yükleniyor…',
      tarFallback: 'Bazı dosyalar arşivlenemedi. Doğrudan yükleme deneniyor…',
      tarPartial: '{{failed}} dosya arşivlenemedi/yüklenemedi ve kuyrukta bırakıldı.',
      directPartial: '{{failed}} dosya yüklenemedi ve kuyrukta bırakıldı.',
      noFiles: 'Yüklenecek dosya seçilmedi.',
      noQueuedFiles: 'Yüklemek için önce dosya veya klasör ekleyin.',
      queueNoNewFiles: 'Yeni bir dosya eklenmedi; seçilenler zaten kuyrukta.',
      queueAdded: '{{count}} öğe kuyruğa eklendi. Klasör sayısı: {{folderCount}}',
      dropFolderReadFailed: 'Sürüklenen klasörler okunamadı.',
      chooseFoldersFailed: 'Seçilen klasörler okunamadı.',
      relativePathMissing:
        'Klasör yapısı bilgisi yok. Seçilen öğeler düz dosya olarak yüklenecek.',
      uploadedCount: '{{count}} dosya /root/uploads/{{path}} konumuna yüklendi.',
      uploadFailedNetwork: 'Yükleme başarısız (ağ hatası).',
      enterFolderName: 'Lütfen bir klasör adı girin.',
      folderCreated: 'Klasör oluşturuldu.',
      folderCreateFailed: 'Klasör oluşturulamadı (ağ hatası).',
    },
  },
  itUsersList: {
    title: 'IT Kullanıcı Listesi',
    loading: 'Kullanıcılar yükleniyor...',
    loadError: 'Kullanıcılar yüklenirken hata oluştu.',
    columns: {
      username: 'Kullanıcı Adı',
      personnel: 'Personel',
      personnelId: 'Personel ID',
      role: 'Rol',
      status: 'Durum',
      lastLogin: 'Son Giriş',
    },
    filters: {
      searchPlaceholder: 'Kullanıcı adı, personel, personel ID, rol...',
      rolePlaceholder: 'Rol',
      statusPlaceholder: 'Durum',
    },
    roles: {
      admin: 'Admin',
      user: 'User',
      readonly: 'Readonly',
    },
    status: {
      active: 'Aktif',
      inactive: 'Pasif',
    },
  },
};

export default tr;

